export const QT2GValuesModel = {
    ntp_server: "-1",
    tz: "-1",
    sync: "-1",
}
export const QT2GHasModel = {
    has_ntp_server: false,
    has_tz: false,
    has_sync: false,
}